import { useState } from 'react';
import { Box } from '@mui/material';
import { Button, Form } from '../../../2-component';

export const WorkflowCompletionForm = (props: React.ComponentProps<typeof Form> & {
  submitButtonProps?: Omit<React.ComponentProps<typeof Button>, 'loading'>,
  buttonFooter?: React.ReactNode,
  showSubmitButton?: boolean,
}) => {
  const {
    submitButtonProps = { label: 'Submit' },
    buttonFooter,
    showSubmitButton = true,
    ...rest
  } = props;
  const [disabled, setDisabled] = useState(false);

  const submit = async () => {
    setDisabled(true);
    await rest.onSubmit();
    setDisabled(false);
  };

  return (
    <Form {...rest} onSubmit={submit}>
      {rest.children}
      <Box display='flex' justifyContent='flex-end'>
        {buttonFooter}
        {showSubmitButton && <Button
          {...submitButtonProps}
          sx={{ mt: 3, textAlign: 'center' }}
          type='submit'
          disabled={disabled || submitButtonProps.disabled}
        />}
      </Box>
    </Form >
  );
};
